import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import GoalStaticsEmpRow from './GoalStaticsEmpRow';

const useStyles = makeStyles({
  table: {
    borderCollapse: 'collapse',
    // 모든 셀에 회색 테두리 적용
    '& .MuiTableCell-root': {
      border: '1px solid #e0e0e0',
      padding: '4px 8px',
      fontSize: '0.85rem',
      height: '40px',
    },
    // 헤더 영역 배경색 및 글꼴 설정
    '& .MuiTableHead-root .MuiTableCell-root': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
      color: '#333',
    },
    // 하늘색 배경 스타일 - 글자색 검정(#333)으로 통일
    '& .header-sky': {
      backgroundColor: '#e3f2fd !important',
      color: '#333',
    },
    '& .subtotal-row': {
      backgroundColor: '#fafafa',
      fontWeight: '600',
    }
  },
});

const GoalStaticsEmpTable = ({ loading, data, tableRef, headerRows, selectedLabel }) => {
  const classes = useStyles();

  if (loading || !data) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ my: 1 }}>
      {/* 1. (단위:원)을 Paper 바깥으로 이동 */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5, pr: 1, fontSize: '0.8rem', color: '#666' }}>
        (단위:원)
      </Box>

      {/* 2. 테이블 본체 */}
      <Paper elevation={1} sx={{ overflow: 'auto' }}>
        <TableContainer sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
          <Table size="small" className={classes.table} ref={tableRef}>
            <TableHead>
              <TableRow>
                <TableCell align="center" rowSpan={2} sx={{ fontWeight: 'bold' }}>본부</TableCell>
                <TableCell align="center" rowSpan={2} sx={{ fontWeight: 'bold' }}>팀</TableCell>
                <TableCell align="center" rowSpan={2} sx={{ fontWeight: 'bold' }}>팀원</TableCell>
                {/* 목표금액 헤더 */}
                <TableCell align="center" colSpan={headerRows.length} className="header-sky" sx={{ fontWeight: 'bold' }}>
                  {selectedLabel} 목표
                </TableCell>
              </TableRow>
              <TableRow>
                {headerRows.map((header, index) => (
                  <TableCell key={index} align="center" className="header-sky" sx={{ fontWeight: 'bold' }}>
                    {header !== 'total' ? `${header}월` : `합계`}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <GoalStaticsEmpRow data={data} headers={headerRows} />
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default GoalStaticsEmpTable;
